const CONFIG_TABLE_TAB_7 = (data = {}) => {
    return {
        headers: [
            {
                label: data?.label1 ?? '当選人数',
                bgClass: 'bg-color5',
                width: '150px'
            },
            {
                label: data?.label2 ?? '',
                bgClass: 'bg-color5',
                width: '180px'
            },
            {
                label: data?.label3 ?? '当選者',
                bgClass: 'bg-color5',
                width: '100px'
            },
            {
                label: data?.label4 ?? '予備当選者',
                bgClass: 'bg-color5',
                width: '100px'
            },
            {
                label: data?.label5 ?? '',
                bgClass: 'bg-color5',
                width: '320px'
            },
            {
                label: data?.label6 ?? '計',
                colspan: 2,
                width: '40px',
                bgClass: 'bg-color5'
            },
            {
                label: data?.label7 ?? '1次チェック',
                width: '105px'
            },
            {
                label: data?.label8 ?? '2次チェック',
                width: '105px'
            }
        ]
    };
};
const CONFIG_TABLE_TAB_8 = (data = {}) => {
    return {
        headers: CONFIG_TABLE_TAB_7(data).headers
    };
};

const CONFIG_TABLE_TAB_9 = (data = {}) => {
    return {
        headers: [
            {
                label: data?.label1 ?? '当選人数',
                bgClass: 'bg-color3',
                width: '200px'
            },
            {
                label: data?.label2 ?? '',
                bgClass: 'bg-color3',
                width: '260px'
            },
            {
                label: data?.label3 ?? '当選者',
                bgClass: 'bg-color3',
                width: '100px'
            },
            {
                label: data?.label4 ?? '予備当選者',
                bgClass: 'bg-color3',
                width: '100px'
            },
            {
                label: data?.label5 ?? '',
                bgClass: 'bg-color3',
                width: '320px'
            },
            {
                label: data?.label6 ?? '計',
                colspan: 2,
                width: '40px'
            },
            {
                label: data?.label7 ?? '1次チェック',
                width: '105px'
            },
            {
                label: data?.label8 ?? '2次チェック',
                width: '105px'
            }
        ]
    };
};

const CONFIG_TABLE_TAB_10 = (data = {}) => {
    return {
        headers: [
            {
                label: data?.label1 ?? '当選人数',
                bgClass: 'bg-color4',
                width: '150px'
            },
            {
                label: data?.label2 ?? '',
                bgClass: 'bg-color4',
                width: '260px'
            },
            {
                label: data?.label3 ?? '当選者',
                bgClass: 'bg-color4',
                width: '100px'
            },
            {
                label: data?.label4 ?? '予備当選者',
                bgClass: 'bg-color4',
                width: '100px'
            },
            {
                label: data?.label5 ?? '',
                bgClass: 'bg-color4',
                width: '320px'
            },
            {
                label: data?.label6 ?? '計',
                colspan: 2,
                width: '40px',
                bgClass: 'bg-color4'
            },
            {
                label: data?.label7 ?? '1次チェック',
                width: '105px'
            },
            {
                label: data?.label8 ?? '2次チェック',
                width: '105px'
            }
        ]
    };
};

const CONFIG_TABLE_TAB_11 = (data = {}) => {
    return {
        headers: CONFIG_TABLE_TAB_7(data).headers
    };
};

export { CONFIG_TABLE_TAB_7, CONFIG_TABLE_TAB_8, CONFIG_TABLE_TAB_9, CONFIG_TABLE_TAB_10, CONFIG_TABLE_TAB_11 };
